import { render, staticRenderFns } from "./InputFoto.vue?vue&type=template&id=de89afea&"
import script from "./InputFoto.vue?vue&type=script&lang=js&"
export * from "./InputFoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports